// extracted by mini-css-extract-plugin
export var container = "style-module--container--bded0";
export var head = "style-module--head--c92c4";
export var linkContainer = "style-module--linkContainer--42898";
export var play = "style-module--play--54b76";
export var sectionHeadline = "style-module--sectionHeadline--0e46c";
export var spLinkContainer = "style-module--spLinkContainer--fb45a";
export var subLine = "style-module--subLine--035c0";